// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__3mNco","inputWrap":"CustomTip_inputWrap__3M9Fx"};